import { Breadcrumbs, Typography } from "@material-ui/core";
import { Link, useTranslate } from "react-admin";
import resourceNames from "../../../common/data/resourceNames";
import { SelectedDriver, DriverBreadcrumb } from "./DriverBreadcrumb";

interface BreadcrumbProps {
  driver?: SelectedDriver;
}

export const Breadcrumb = ({ driver }: BreadcrumbProps) => {
  const translate = useTranslate();
  return driver ? (
    <Breadcrumbs aria-label="breadcrumb" className="vehicle-breadcrumbs">
      <Link to={`/${resourceNames.SAFETY_DASHBOARD}`}>
        <Typography variant="h6">
          {translate("resources.maintenance-dashboard.name")}
        </Typography>
      </Link>
      <DriverBreadcrumb
        driver={driver}
        getBasePath={(x) =>
          x
            ? `/${resourceNames.SAFETY_DASHBOARD}/${x.id}`
            : `/${resourceNames.SAFETY_DASHBOARD}`
        }
      />
    </Breadcrumbs>
  ) : (
    <div className="maintenance-dashboard-title">
      <Link to={`/${resourceNames.SAFETY_DASHBOARD}`}>
        <Typography variant="h6">
          {translate("resources.maintenance-dashboard.name")}
        </Typography>
      </Link>
      <DriverBreadcrumb
        getBasePath={(x) =>
          x
            ? `/${resourceNames.SAFETY_DASHBOARD}/${x.id}`
            : `/${resourceNames.SAFETY_DASHBOARD}`
        }
      />
    </div>
  );
};
